import { getSetting } from '@woocommerce/settings';
import parse from 'html-react-parser';
import { __ } from '@wordpress/i18n';
import { extensionCartUpdate } from '@woocommerce/blocks-checkout';
export const Block = ( { checkoutExtensionData, extensions } ) => {
	const { setExtensionData } = checkoutExtensionData;
	const { checkout_fields, user_data, general_settings } = getSetting( 'delivery-calculation_data');
	// console.log(general_settings);
	var date_hidden = general_settings.cm_show_hide_datepicker;
	var date_required = general_settings.cm_required_datepicker;
	var timesettings = general_settings.cm_timepicker_settings;
	var timeHidden = timesettings.cm_show_hide_timepicker;
	var timerequired = timesettings.cm_required_timepicker;
	var isMapCalculatorReq = general_settings.address_settings.cm_map_calculator_req;
	const handleDatePicker = () => {
		if ( document.getElementById('wccdp-custom-date-picker') ) {
			setExtensionData( 'calculate-prices-based-on-distance-for-wooCommerce', 'wccpd_custom_date_picker', document.getElementById('wccdp-custom-date-picker').value );
		}
    };
	const handleStoreOption = () => {
		if ( document.querySelector('.cm-store-options') ) {
			setExtensionData( 'calculate-prices-based-on-distance-for-wooCommerce', 'cm_select_del_option', document.querySelector('.cm-store-options').value );
		}
    };
	const handleTimePicker = () => {
		if ( document.getElementById('wccdp-custom-time-picker') ) {
			setExtensionData( 'calculate-prices-based-on-distance-for-wooCommerce', 'wccpd_custom_time_picker', document.getElementById('wccdp-custom-time-picker').value )
		}
    };
	const handleAddress = () => {
		// setTimeout(function(){
			var addres_input_val = document.querySelector('#wccpd-street-address').value;
			var city             = document.querySelector('#wccpd-towncity').value;
			var country          = document.querySelector('#wccpd-country').value;
			var postcode         = document.querySelector('#wccpd-postalcode').value;
			var addres_string    = `${addres_input_val} ${city} ${country} ${postcode}`;
			// var pickupaddres_string    = document.querySelector('.custom-address-pickup').value;
			setExtensionData( 'calculate-prices-based-on-distance-for-wooCommerce', 'wccpd_delivery_address', addres_string );
			addres_input_val = jQuery('.custom-address-pickup').val();
			city             = jQuery('.cm-town-city-pickup').val();
			country          = jQuery('.cm-fe-country-pickup').val();
			postcode         = jQuery('.cm-fe-postcode-pickup').val();
			addres_string    = `${addres_input_val} ${city} ${country} ${postcode}`;
			setExtensionData( 'calculate-prices-based-on-distance-for-wooCommerce', 'cm_save_pickup_address', addres_string );
		// }, 2000);
    };
	function wccpd_validation() {
		// setTimeout(function() {
			// wp.data.dispatch('wc/store/cart').invalidateResolutionForStore()
			var placeOrderButton = document.querySelector('.wc-block-components-checkout-place-order-button');
			if (placeOrderButton) {
				// placeOrderButton.addEventListener('mouseenter', function(event) {
				// 	handleDatePicker();
				// 	handleTimePicker();
				// 	handleAddress();
				// 	handleStoreOption();
				// });
                placeOrderButton.addEventListener('click', function(event) {
                    let selectedDate = document.querySelector(".custom-date-picker")?.value || "";
                    let selectedTime = document.querySelector(".custom-time-picker")?.value || "";
					let address_calculation = document.querySelector(".cm-calculate-fee");
					var isAddressCalculated = address_calculation.getAttribute('data-address_calculated');
					if ( "showhide" === date_hidden ) {
						selectedDate = true;
					}
					if ( "required" !== date_required ) {
						selectedDate = true;
					}
					if ( "showhidetime" === timeHidden ) {
						selectedTime = true;
					}
					if ( "requiredtime" !== timerequired ) {
						selectedTime = true;
					}
					if ( "cm_map_calculator_req" !== isMapCalculatorReq ) {
						isAddressCalculated = true;
					}
					if ( !selectedDate ) {
						swal({
							title: 'Please Choose The Date',
							icon: "error",
							timer: 4000,
							buttons: true
						});
                    }
                    if ( !selectedTime ) {
						swal({
							title: 'Please Choose The Time Slot',
							icon: "error",
							timer: 4000,
							buttons: true
						});
                    }
					if ( !isAddressCalculated && 'StorePickup' !== document.querySelector('.cm-store-options').value ) {
						swal({
							title: 'Please Calculate Address',
							icon: "error",
							timer: 4000,
							buttons: true
						});
					}
                    // if ( !selectedDate || !selectedTime || !isAddressCalculated ) {
					if (!selectedDate || !selectedTime || (!isAddressCalculated && document.querySelector('.cm-store-options').value !== 'StorePickup')) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                    }
					handleDatePicker();
					handleTimePicker();
					handleAddress();
					handleStoreOption();
                });
            }
			jQuery(document).ajaxComplete(function(event, xhr, settings) {
				wp.data.dispatch('wc/store/cart').invalidateResolutionForStore();
				////// update cart
				extensionCartUpdate( {
					namespace: 'calculate-prices-based-on-distance-for-wooCommerce',
				} ).then( () => {} ).catch( ( error ) => {} );
				//////
			});
			jQuery(document).on('click', '#cm-copy-billing', function(event, xhr, settings) {
				if(jQuery(this).is(":checked")){
					var wc_street_address = user_data.billing_address_1 ? user_data.billing_address_1 : jQuery('#billing-address_1').val();
					var wc_billing_city = user_data.billing_city ? user_data.billing_city : jQuery('#billing-city').val();
					var wc_country = user_data.billing_country ? user_data.billing_country : jQuery('#billing-country').find(":selected").text();
					var wc_billing_postcode = user_data.billing_postcode ? user_data.billing_postcode : jQuery('#billing-postcode').val();	
					jQuery('.custom-address').val(wc_street_address);
					jQuery('.cm-town-city').val(wc_billing_city);
					jQuery('.cm-fe-country').val(wc_country);
					jQuery('.cm-fe-postcode').val(wc_billing_postcode);
				}else{
					jQuery('.cm-empty-copy-billing').each(function(){
						jQuery(this).val('');
					})
				}
			});
		// }, 1000);
	}
	if ( null === checkout_fields || !checkout_fields ) {
		return;
	}
	const checkout_fields_html = parse(checkout_fields);
	setTimeout(function() {
		wccpd_validation();
		// document.querySelector('.cm-store-options').addEventListener('change', handleStoreOption);
		// jQuery(document).on('click', '.ui-menu-item', function(e) {
		// 	// jQuery(this).find('.ui-corner-all').text()
		// 	handleTimePicker();
		// });
		// jQuery(document).on('click', 'a.ui-state-default', function(e) {
		// 	handleDatePicker();
		// });
		// // address
		// document.getElementById('wccpd-street-address').addEventListener('change', handleAddress);
  		// document.getElementById('wccpd-towncity').addEventListener('change', handleAddress);
		// document.getElementById('wccpd-country').addEventListener('change', handleAddress);
  		// document.getElementById('wccpd-postalcode').addEventListener('change', handleAddress);
		//   let paymentSection = document.querySelector('.wp-block-woocommerce-checkout-payment-block');
		//   let delivery_content = document.querySelector('.custom-container');
		//   delivery_content.insertAfter(paymentSection);

		let paymentSection = jQuery('.wp-block-woocommerce-checkout-payment-block');
		let deliveryContent = jQuery('.wccpd-custom-container');

		if (paymentSection.length && deliveryContent.length) {
			deliveryContent.insertAfter(paymentSection);
		}

	}, 1000);
	return (
		<div className="wp-block-delivery-cost-calculation">
			{checkout_fields_html}
		</div>
	);
};